export const FEATURE_FLAGS = Object.freeze({
  MIGRATION_TO_API_V3: 'MIGRATION_TO_API_V3',
  VISIT_DONE_V3: 'VISIT_DONE_V3',
  REGISTER_VISIT_V3: 'REGISTER_VISIT_V3',
  VISIT_CONFIRMATION_BY_AGENT: 'VISIT_CONFIRMATION_BY_AGENT',
  VISIT_DETAIL_STATUS_COMPONENT_V2: 'visit_detail_status_component_v2',
  VISIT_STATUS_UNAVAILABLE_HOURS: 'visit_status_unavailable_hours',
  OFFER_STATUS_LIST: 'OFFER_STATUS_LIST',
  AGENTS_EARLY_DEMAND: 'AGENTS_EARLY_DEMAND',
  VISIT_AUTOMATIC_CANCELLATION: 'visit_automatic_cancellation',
  DISABLED_CRM_OFFER_FILTERS: 'disable_crm_offer_filters',
  ENABLE_PORTFOLIO_LOGIN: 'enablePortfolioLogin',
  NEW_MENU_LAYOUT: 'new_menu_layout',
  NEW_MENU_HOME_ITEM: 'new_menu_home_item',
  FIND_WEBAPP_LOGIN_REDIRECT_FLAG: 'find_webapp_login_redirect_enabled',
  AGENTS_API_RETRY: 'agents_api_retry',
  RETRY_MAX_RETRIES: 'retry_max_retries',
  RETRY_TIMEOUT_MS: 'retry_timeout_ms',
  REDIRECT_TO_IDENTITY: 'redirect_to_identity',
  LR_CR_CHAT_V2: 'lr_cr_chat_v2',
  ENTRY_ACCESS_ROUTES_AGENTS_API_ENABLED:
    'entry_access_routes_agents_api_enabled',
});

export const FEATURE_FLAGS_KEYS = Object.freeze({
  [FEATURE_FLAGS.MIGRATION_TO_API_V3]: 'MIGRATION_TO_API_V3',
  [FEATURE_FLAGS.VISIT_DONE_V3]: 'VISIT_DONE_V3',
  [FEATURE_FLAGS.REGISTER_VISIT_V3]: 'REGISTER_VISIT_V3',
  [FEATURE_FLAGS.VISIT_CONFIRMATION_BY_AGENT]: 'VISIT_CONFIRMATION_BY_AGENT',
  [FEATURE_FLAGS.VISIT_DETAIL_STATUS_COMPONENT_V2]:
    'visit_detail_status_component_v2',
  [FEATURE_FLAGS.VISIT_STATUS_UNAVAILABLE_HOURS]:
    'visit_status_unavailable_hours',
  [FEATURE_FLAGS.OFFER_STATUS_LIST]: 'offer_status_list',
  [FEATURE_FLAGS.AGENTS_EARLY_DEMAND]: 'agents_early_demand',
  [FEATURE_FLAGS.VISIT_AUTOMATIC_CANCELLATION]: 'visit_automatic_cancellation',
  [FEATURE_FLAGS.ENABLE_PORTFOLIO_LOGIN]: 'enablePortfolioLogin',
  [FEATURE_FLAGS.DISABLED_CRM_OFFER_FILTERS]: 'disable_crm_offer_filters',
  [FEATURE_FLAGS.NEW_MENU_LAYOUT]: 'new_menu_layout',
  [FEATURE_FLAGS.AGENTS_API_RETRY]: 'agents_api_retry',
  [FEATURE_FLAGS.RETRY_MAX_RETRIES]: 'retry_max_retries',
  [FEATURE_FLAGS.RETRY_TIMEOUT_MS]: 'retry_timeout_ms',
  [FEATURE_FLAGS.LR_CR_CHAT_V2]: 'lr_cr_chat_v2',
});

export const FEATURE_FLAGS_ENABLED = Object.freeze({
  [FEATURE_FLAGS.MIGRATION_TO_API_V3]: 'isMigrationToApiV3Enabled',
  [FEATURE_FLAGS.VISIT_DONE_V3]: 'isVisitDoneV3Enabled',
  [FEATURE_FLAGS.REGISTER_VISIT_V3]: 'isRegisterVisitV3Enabled',
  [FEATURE_FLAGS.VISIT_CONFIRMATION_BY_AGENT]:
    'isVisitConfirmationByAgentEnabled',
  [FEATURE_FLAGS.VISIT_DETAIL_STATUS_COMPONENT_V2]:
    'isVisitDetailStatusComponentV2Enabled',
  [FEATURE_FLAGS.VISIT_STATUS_UNAVAILABLE_HOURS]:
    'isVisitStatusUnavailableHoursEnabled',
  [FEATURE_FLAGS.AGENTS_EARLY_DEMAND]: 'isAgentsEarlyDemandEnabled',
  [FEATURE_FLAGS.VISIT_AUTOMATIC_CANCELLATION]:
    'isVisitAutomaticCancellationEnabled',
  [FEATURE_FLAGS.ENABLE_PORTFOLIO_LOGIN]: 'isPortfolioLoginEnabled',
  [FEATURE_FLAGS.AGENTS_API_RETRY]: 'isAgentsApiRetryEnabled',
  [FEATURE_FLAGS.RETRY_MAX_RETRIES]: 'retryMaxRetries',
  [FEATURE_FLAGS.RETRY_TIMEOUT_MS]: 'retryTimeoutMs',
});
